module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0071.png.087a043c.jpg";